var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('moon-loader',{staticStyle:{"position":"fixed"},attrs:{"loading":_vm.getIsLoading,"color":"#1e4380"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }